import type { DataNode } from 'antd/es/tree';

export const detailColumnTree: DataNode[] = [
    { title: '预约管理', key: 'appointment' },
    {
        title: '维修管理', key: 'orderManage', selectable: false,
        children: [
            { title: '维修工单', key: 'order' },
            { title: '维修退单', key: 'orderReturn' }
        ]
    },
    {
        title: '销售管理', key: 'saleManage', selectable: false,
        children: [
            { title: '销售订单', key: 'saleOrder' },
            { title: '销售单', key: 'sale' },
            { title: '销售退货', key: 'saleReturn' },
            { title: '调出单', key: 'saleOut' }
        ]
    },
    {
        title: '库存管理', key: 'stockManage', selectable: false,
        children: [
            { title: '库存明细', key: 'stockDetail' },
            { title: '库存统计', key: 'stockStatic' },
            { title: '库存盘点', key: 'stockCheck' },
            { title: '维修出库', key: 'stockDelivery' },
            { title: '维修借件', key: 'stockBorrow' },
            { title: '出库单据', key: 'stockOut' },
            { title: '入库单据', key: 'stockIn' },
            { title: '调拨管理', key: 'stockAlloc' },
        ]
    },
    {
        title: '采购管理', key: 'purchaseManage', selectable: false,
        children: [
            { title: '采购计划', key: 'purchasePlan' },
            { title: '采购单', key: 'purchase' },
            { title: '采购退货单', key: 'purchaseReturn' },
            { title: '调入单', key: 'purchaseIn' },
        ]
    },
    {
        title: '统计分析', key: 'staticManage', selectable: false,
        children: [
            { title: '出入库明细报表', key: 'inOutDetailStatic' },
            { title: '采购明细报表', key: 'purchaseDetailStatic' },
            { title: '销售明细报表', key: 'saleDetailStatic' },
            { title: '维修明细报表', key: 'orderDetailStatic' },
            { title: '采购订单台账', key: 'purchaseOrderLog' },
        ]
    },
    { title: '其他', key: 'other' },
];

export const detailColumns: any[] = [
    //预约管理
    { model: "appointment", type: "主单", showable: "1", name: '预约单号', code: 'appointmentCode' },
    { model: "appointment", type: "主单", showable: "1", name: '预约状态', code: 'status' },
    { model: "appointment", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "appointment", type: "主单", showable: "1", name: '送修人', code: 'contact' },
    { model: "appointment", type: "主单", showable: "1", name: '送车电话', code: 'phone' },
    { model: "appointment", type: "主单", showable: "1", name: '车牌号', code: 'licensePlate' },
    { model: "appointment", type: "主单", showable: "1", name: 'VIN码', code: 'vin' },
    { model: "appointment", type: "主单", showable: "1", name: '车辆类型', code: 'vehicleTypeName' },
    { model: "appointment", type: "主单", showable: "1", name: '车辆型号', code: 'vehicleModel' },
    { model: "appointment", type: "主单", showable: "1", name: '维修类型', code: 'serviceNatureName' },
    { model: "appointment", type: "主单", showable: "1", name: '工时费', code: 'workingHoursAmount' },
    { model: "appointment", type: "主单", showable: "1", name: '配件费', code: 'materialScienceAmount' },
    { model: "appointment", type: "主单", showable: "1", name: '费用合计', code: 'totalAmount' },
    { model: "appointment", type: "主单", showable: "1", name: '优惠金额', code: 'discountTotalAmount' },
    { model: "appointment", type: "主单", showable: "1", name: '营业额', code: 'receivableTotalAmount' },
    { model: "appointment", type: "主单", showable: "1", name: '销售毛利', code: 'grossProfit' },
    { model: "appointment", type: "主单", showable: "1", name: '销售成本', code: 'totalCost' },
    { model: "appointment", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "appointment", type: "主单", showable: "1", name: '结算方', code: 'settlementPartyName' },
    { model: "appointment", type: "主单", showable: "1", name: '服务地点', code: 'serviceLocationName' },
    { model: "appointment", type: "主单", showable: "1", name: '预约进厂时间', code: 'enterTime' },
    { model: "appointment", type: "主单", showable: "1", name: '预估出厂时间', code: 'deliveryTime' },
    { model: "appointment", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "appointment", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },
    { model: "appointment", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "appointment", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "appointment", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },
    //预约管理明细-维修项目
    { model: "appointment", type: "维修项目", showable: "1", name: '项目编码', code: 'itemCode' },
    { model: "appointment", type: "维修项目", showable: "1", name: '项目名称', code: 'itemName' },
    { model: "appointment", type: "维修项目", showable: "1", name: '工时', code: 'workHour' },
    { model: "appointment", type: "维修项目", showable: "1", name: '单价', code: 'price' },
    { model: "appointment", type: "维修项目", showable: "1", name: '工时费', code: 'itemAmount' },
    { model: "appointment", type: "维修项目", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "appointment", type: "维修项目", showable: "1", name: '小计', code: 'receivableAmount' },
    { model: "appointment", type: "维修项目", showable: "1", name: '备注', code: 'note' },
    //预约管理明细-维修用料
    { model: "appointment", type: "维修用料", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "appointment", type: "维修用料", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "appointment", type: "维修用料", showable: "1", name: '规格型号', code: 'model' },
    { model: "appointment", type: "维修用料", showable: "1", name: '单位', code: 'unitName' },
    { model: "appointment", type: "维修用料", showable: "1", name: '可用库存', code: 'inventoryNum' },
    { model: "appointment", type: "维修用料", showable: "1", name: '库房', code: 'warehouseName' },
    { model: "appointment", type: "维修用料", showable: "1", name: '数量', code: 'num' },
    { model: "appointment", type: "维修用料", showable: "1", name: '单价', code: 'price' },
    { model: "appointment", type: "维修用料", showable: "1", name: '配件费', code: 'materialAmount' },
    { model: "appointment", type: "维修用料", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "appointment", type: "维修用料", showable: "1", name: '小计', code: 'receivableAmount' },
    { model: "appointment", type: "维修用料", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "appointment", type: "维修用料", showable: "1", name: '采购单号', code: 'appointmentCode' },
    { model: "appointment", type: "维修用料", showable: "1", name: '备注', code: 'note' },

    //预约管理明细-新增项目
    { model: "appointment", type: "新增项目", showable: "1", name: '工时', code: 'workHours', editable: "1" },
    { model: "appointment", type: "新增项目", showable: "1", name: '单价', code: 'price' },
    { model: "appointment", type: "新增项目", showable: "1", name: '工时费', code: 'amount' },

    //预约管理明细-新增商品
    { model: "appointment", type: "新增商品", showable: "1", name: '价格', code: 'price' },
    { model: "appointment", type: "新增商品", showable: "1", name: '总计', code: 'amount' },

    //维修工单
    { model: "order", type: "主单", showable: "1", name: '工单单号', code: 'maintenanceCode' },
    { model: "order", type: "主单", showable: "1", name: '工单状态', code: 'status' },
    { model: "order", type: "主单", showable: "1", name: '退单状态', code: 'returnType' },
    { model: "order", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "order", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "order", type: "主单", showable: "1", name: 'VIN码', code: 'vin' },
    { model: "order", type: "主单", showable: "1", name: '车牌号', code: 'licensePlate' },
    { model: "order", type: "主单", showable: "1", name: '送修人', code: 'contact' },
    { model: "order", type: "主单", showable: "1", name: '送车电话', code: 'phone' },
    { model: "order", type: "主单", showable: "1", name: '车辆类型', code: 'vehicleTypeName' },
    { model: "order", type: "主单", showable: "1", name: '车辆型号', code: 'vehicleModel' },
    { model: "order", type: "主单", showable: "1", name: '维修类型', code: 'serviceNatureName' },
    { model: "order", type: "主单", showable: "1", name: '维修工', code: 'technicianNames' },
    { model: "order", type: "主单", showable: "1", name: '配件数', code: 'materialNum' },
    { model: "order", type: "主单", showable: "1", name: '工时数', code: 'workHour' },
    { model: "order", type: "主单", showable: "1", name: '工时费', code: 'workingHoursAmount' },
    { model: "order", type: "主单", showable: "1", name: '配件费', code: 'materialScienceAmount' },
    { model: "order", type: "主单", showable: "1", name: '费用合计', code: 'totalAmount' },
    { model: "order", type: "主单", showable: "1", name: '优惠金额', code: 'discountTotalAmount' },
    { model: "order", type: "主单", showable: "1", name: '优惠后工时费', code: 'workHourAmount' },
    { model: "order", type: "主单", showable: "1", name: '优惠后配件费', code: 'materialHourAmount' },
    { model: "order", type: "主单", showable: "1", name: '营业额', code: 'receivableTotalAmount' },
    { model: "order", type: "主单", showable: "1", name: '已收金额', code: 'receivableAmount' },
    { model: "order", type: "主单", showable: "1", name: '销售毛利', code: 'grossProfit' },
    { model: "order", type: "主单", showable: "1", name: '销售成本', code: 'totalCost' },
    { model: "order", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "order", type: "主单", showable: "1", name: '结算方式', code: 'paymentMethodName' },
    { model: "order", type: "主单", showable: "1", name: '结算方', code: 'settlementPartyName' },
    { model: "order", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "order", type: "主单", showable: "1", name: '发票编号', code: 'invoiceNum' },
    { model: "order", type: "主单", showable: "1", name: '开票状态', code: 'invoiceStatus' },
    { model: "order", type: "主单", showable: "1", name: '服务地点', code: 'serviceLocationName' },
    { model: "order", type: "主单", showable: "1", name: '进厂时间', code: 'enterTime' },
    { model: "order", type: "主单", showable: "1", name: '出厂时间', code: 'deliveryTime' },
    { model: "order", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "order", type: "主单", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "order", type: "主单", showable: "1", name: '结算员', code: 'reckoner' },
    { model: "order", type: "主单", showable: "1", name: '结算时间', code: 'settleTime' },
    { model: "order", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },
    { model: "order", type: "主单", showable: "1", name: '预约单号', code: 'appointmentCode' },
    { model: "order", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "order", type: "主单", showable: "1", name: '退单原因', code: 'returnReason' },
    { model: "order", type: "主单", showable: "1", name: '财务备注', code: 'fmsNote' },
    { model: "order", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "order", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //维修工单明细-维修项目
    { model: "order", type: "维修项目", showable: "1", name: '项目编码', code: 'itemCode' },
    { model: "order", type: "维修项目", showable: "1", name: '项目名称', code: 'itemName' },
    { model: "order", type: "维修项目", showable: "1", name: '工时', code: 'workHour', editable: "1" },
    { model: "order", type: "维修项目", showable: "1", name: '单价', code: 'price', editable: "1" },
    { model: "order", type: "维修项目", showable: "1", name: '工时费', code: 'itemAmount' },
    { model: "order", type: "维修项目", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "order", type: "维修项目", showable: "1", name: '小计', code: 'receivableAmount' },
    { model: "order", type: "维修项目", showable: "1", name: '备注', code: 'note' },

    //维修工单明细-维修用料
    { model: "order", type: "维修用料", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "order", type: "维修用料", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "order", type: "维修用料", showable: "1", name: '单位', code: 'unitName' },
    { model: "order", type: "维修用料", showable: "1", name: '可用库存', code: 'inventoryNum' },
    { model: "order", type: "维修用料", showable: "1", name: '库房', code: 'warehouseName' },
    { model: "order", type: "维修用料", showable: "1", name: '数量', code: 'num' },
    { model: "order", type: "维修用料", showable: "1", name: '单价', code: 'price' },
    { model: "order", type: "维修用料", showable: "1", name: '配件费', code: 'materialAmount' },
    { model: "order", type: "维修用料", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "order", type: "维修用料", showable: "1", name: '折后金额', code: 'discountedAmount' },
    { model: "order", type: "维修用料", showable: "1", name: '单项优惠金额', code: 'decreaseAmount' },
    { model: "order", type: "维修用料", showable: "1", name: '小计', code: 'receivableAmount' },
    { model: "order", type: "维修用料", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "order", type: "维修用料", showable: "1", name: '采购单号', code: 'orderCode' },
    { model: "order", type: "维修用料", showable: "1", name: '备注', code: 'note' },

    //预约管理明细-新增项目
    { model: "order", type: "新增项目", showable: "1", name: '工时', code: 'workHours', editable: "1" },
    { model: "order", type: "新增项目", showable: "1", name: '单价', code: 'price' },
    { model: "order", type: "新增项目", showable: "1", name: '工时费', code: 'amount' },

    //维修工单明细-新增商品
    { model: "order", type: "新增商品", showable: "1", name: '价格', code: 'price' },
    { model: "order", type: "新增商品", showable: "1", name: '总计', code: 'amount' },

    //维修退单
    { model: "orderReturn", type: "主单", showable: "1", name: '退单单号', code: 'returnCode' },
    { model: "orderReturn", type: "主单", showable: "1", name: '工单单号', code: 'maintenanceCode' },
    { model: "orderReturn", type: "主单", showable: "1", name: '退单状态', code: 'status' },
    { model: "orderReturn", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "orderReturn", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "orderReturn", type: "主单", showable: "1", name: 'VIN码', code: 'vin' },
    { model: "orderReturn", type: "主单", showable: "1", name: '车牌号', code: 'licensePlate' },
    { model: "orderReturn", type: "主单", showable: "1", name: '送修人', code: 'contact' },
    { model: "orderReturn", type: "主单", showable: "1", name: '送车电话', code: 'phone' },
    { model: "orderReturn", type: "主单", showable: "1", name: '车辆类型', code: 'vehicleTypeName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '车辆型号', code: 'vehicleModel' },
    { model: "orderReturn", type: "主单", showable: "1", name: '维修类型', code: 'serviceNatureName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '配件数', code: 'materialNum' },
    { model: "orderReturn", type: "主单", showable: "1", name: '工时数', code: 'workHour' },
    { model: "orderReturn", type: "主单", showable: "1", name: '工时费', code: 'workingHoursAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '配件费', code: 'materialScienceAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '费用合计', code: 'totalAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '优惠金额', code: 'discountTotalAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '优惠后工时费', code: 'workHourAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '优惠后配件费', code: 'materialHourAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '营业额', code: 'receivableTotalAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '已收金额', code: 'receivableAmount' },
    { model: "orderReturn", type: "主单", showable: "1", name: '销售毛利', code: 'grossProfit' },
    { model: "orderReturn", type: "主单", showable: "1", name: '销售成本', code: 'totalCost' },
    { model: "orderReturn", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "orderReturn", type: "主单", showable: "1", name: '结算方式', code: 'paymentMethodName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '结算方', code: 'settlementPartyName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '开票状态', code: 'invoiceStatus' },
    { model: "orderReturn", type: "主单", showable: "1", name: '服务地点', code: 'serviceLocationName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '进厂时间', code: 'enterTime' },
    { model: "orderReturn", type: "主单", showable: "1", name: '出厂时间', code: 'deliveryTime' },
    { model: "orderReturn", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "orderReturn", type: "主单", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "orderReturn", type: "主单", showable: "1", name: '结算员', code: 'reckoner' },
    { model: "orderReturn", type: "主单", showable: "1", name: '结算时间', code: 'settleTime' },
    { model: "orderReturn", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },
    { model: "orderReturn", type: "主单", showable: "1", name: '预约单号', code: 'appointmentCode' },
    { model: "orderReturn", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "orderReturn", type: "主单", showable: "1", name: '财务备注', code: 'fmsNote' },
    { model: "orderReturn", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "orderReturn", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //维修工单明细-维修项目
    { model: "orderReturn", type: "维修项目", showable: "1", name: '项目编码', code: 'itemCode' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '项目名称', code: 'itemName' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '工时', code: 'workHour' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '单价', code: 'price' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '工时费', code: 'itemAmount' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '原单折扣', code: 'discountRate' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '原单小计', code: 'receivableAmount' },
    { model: "orderReturn", type: "维修项目", showable: "1", name: '备注', code: 'note' },

    //维修退单明细-维修用料
    { model: "orderReturn", type: "维修用料", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '单位', code: 'unitName' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '可用库存', code: 'inventoryNum' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '库房', code: 'warehouseName' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '数量', code: 'num' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '单价', code: 'price' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '配件费', code: 'materialAmount' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '折后金额', code: 'discountedAmount' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '单项优惠金额', code: 'rdecreaseAmount' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '小计', code: 'receivableAmount' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '采购单号', code: 'purchaseCode' },
    { model: "orderReturn", type: "维修用料", showable: "1", name: '备注', code: 'note' },

    //维修退单明细-新增项目
    { model: "orderReturn", type: "新增项目", showable: "1", name: '单价', code: 'price' },
    { model: "orderReturn", type: "新增项目", showable: "1", name: '工时费', code: 'itemAmount' },
    { model: "orderReturn", type: "新增项目", showable: "1", name: '原单折扣', code: 'discountRate' },
    { model: "orderReturn", type: "新增项目", showable: "1", name: '原单总计', code: 'receivableAmount' },


    //维修退单明细-新增商品
    { model: "orderReturn", type: "新增商品", showable: "1", name: '价格', code: 'price' },
    { model: "orderReturn", type: "新增商品", showable: "1", name: '总计', code: 'materialAmount' },
    { model: "orderReturn", type: "新增商品", showable: "1", name: '原单折扣', code: 'discountRate' },
    { model: "orderReturn", type: "新增商品", showable: "1", name: '原单总计', code: 'receivableAmount' },

    //销售订单
    { model: "saleOrder", type: "主单", showable: "1", name: '销售订单号', code: 'saleOrderCode' },
    { model: "saleOrder", type: "主单", showable: "1", name: '销售单号', code: 'saleCode' },
    { model: "saleOrder", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "saleOrder", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "saleOrder", type: "主单", showable: "1", name: '联系人', code: 'contact' },
    { model: "saleOrder", type: "主单", showable: "1", name: '电话', code: 'phone' },
    { model: "saleOrder", type: "主单", showable: "1", name: '销售类型', code: 'salesTypeName' },
    { model: "saleOrder", type: "主单", showable: "1", name: '订单数量', code: 'totalNum' },
    { model: "saleOrder", type: "主单", showable: "1", name: '订单金额', code: 'totalAmount' },
    { model: "saleOrder", type: "主单", showable: "1", name: '优惠金额', code: 'discountTotalAmount' },
    { model: "saleOrder", type: "主单", showable: "1", name: '营业额', code: 'receivedAmount' },
    { model: "saleOrder", type: "主单", showable: "1", name: '结算方', code: 'settlementPartyName' },
    { model: "saleOrder", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "saleOrder", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "saleOrder", type: "主单", showable: "1", name: '车辆类型', code: 'vehicleTypeName' },
    { model: "saleOrder", type: "主单", showable: "1", name: '车牌号', code: 'licensePlate' },
    { model: "saleOrder", type: "主单", showable: "1", name: 'VIN码', code: 'vin' },
    { model: "saleOrder", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "saleOrder", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "saleOrder", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "saleOrder", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //销售订单明细
    { model: "saleOrder", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "saleOrder", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "saleOrder", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "saleOrder", type: "明细", showable: "1", name: '仓库', code: 'warehouseName' },
    { model: "saleOrder", type: "明细", showable: "1", name: '订单数量', code: 'num' },
    { model: "saleOrder", type: "明细", showable: "1", name: '单价', code: 'price' },
    { model: "saleOrder", type: "明细", showable: "1", name: '金额', code: 'notAmount' },
    { model: "saleOrder", type: "明细", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "saleOrder", type: "明细", showable: "1", name: '零件金额', code: 'amount' },
    { model: "saleOrder", type: "明细", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "saleOrder", type: "明细", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "saleOrder", type: "明细", showable: "1", name: '采购单号', code: 'purchaseCode' },
    { model: "saleOrder", type: "明细", showable: "1", name: '备注', code: 'note' },

    //销售订单明细-新增商品
    { model: "saleOrder", type: "新增商品", showable: "1", name: '价格', code: 'price' },
    { model: "saleOrder", type: "新增商品", showable: "1", name: '总计', code: 'amount' },

    //销售单
    { model: "sale", type: "主单", showable: "1", name: '销售单号', code: 'saleCode' },
    { model: "sale", type: "主单", showable: "1", name: '调拨单号', code: 'transferOrder' },
    { model: "sale", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "sale", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "sale", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "sale", type: "主单", showable: "1", name: '退货状态', code: 'returnStatus' },
    { model: "sale", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "sale", type: "主单", showable: "1", name: '联系人', code: 'contact' },
    { model: "sale", type: "主单", showable: "1", name: '联系电话', code: 'phone' },
    { model: "sale", type: "主单", showable: "1", name: '车辆类型', code: 'vehicleTypeName' },
    { model: "sale", type: "主单", showable: "1", name: '销售类型', code: 'salesTypeName' },
    { model: "sale", type: "主单", showable: "1", name: '销售数量', code: 'totalNum' },
    { model: "sale", type: "主单", showable: "1", name: '销售金额', code: 'totalAmount' },
    { model: "sale", type: "主单", showable: "1", name: '优惠金额', code: 'discountTotalAmount' },
    { model: "sale", type: "主单", showable: "1", name: '营业额', code: 'receivedAmount' },
    { model: "sale", type: "主单", showable: "1", name: '已收金额', code: 'receivableAmount' },
    { model: "sale", type: "主单", showable: "1", name: '销售成本', code: 'totalCost' },
    { model: "sale", type: "主单", showable: "1", name: '销售毛利', code: 'grossProfit' },
    { model: "sale", type: "主单", showable: "1", name: '退货数量', code: 'returnTotalNum' },
    { model: "sale", type: "主单", showable: "1", name: '开票状态', code: 'invoiceStatus' },
    { model: "sale", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "sale", type: "主单", showable: "1", name: '发票编号', code: 'invoiceNum' },
    { model: "sale", type: "主单", showable: "1", name: '结算方', code: 'settlementPartyName' },
    { model: "sale", type: "主单", showable: "1", name: '结算方式', code: 'paymentMethodName' },
    { model: "sale", type: "主单", showable: "1", name: '销售员', code: 'saleUser' },
    { model: "sale", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "sale", type: "主单", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "sale", type: "主单", showable: "1", name: '库管员', code: 'storekeeper' },
    { model: "sale", type: "主单", showable: "1", name: '出库时间', code: 'stockIoTime' },
    { model: "sale", type: "主单", showable: "1", name: '结算员', code: 'reckoner' },
    { model: "sale", type: "主单", showable: "1", name: '结算时间', code: 'settleTime' },
    { model: "sale", type: "主单", showable: "1", name: '核销时间', code: 'writeOffTime' },
    { model: "sale", type: "主单", showable: "1", name: '转接单号', code: 'saleOrderCode' },
    { model: "sale", type: "主单", showable: "1", name: '车牌号', code: 'licensePlate' },
    { model: "sale", type: "主单", showable: "1", name: 'VIN码', code: 'vin' },
    { model: "sale", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "sale", type: "主单", showable: "1", name: '财务备注', code: 'fmsNote' },
    { model: "sale", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "sale", type: "主单", showable: "1", name: '调出单号', code: 'allocationCode' },
    { model: "sale", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //销售单明细
    { model: "sale", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "sale", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "sale", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "sale", type: "明细", showable: "1", name: '仓库', code: 'warehouseName' },
    { model: "sale", type: "明细", showable: "1", name: '销售数量', code: 'num' },
    { model: "sale", type: "明细", showable: "1", name: '单价', code: 'price' },
    { model: "sale", type: "明细", showable: "1", name: '销售金额', code: 'totalAmount' },
    { model: "sale", type: "明细", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "sale", type: "明细", showable: "1", name: '折后金额', code: 'discountedAmount' },
    { model: "sale", type: "明细", showable: "1", name: '单项优惠金额', code: 'decreaseAmount' },
    { model: "sale", type: "明细", showable: "1", name: '小计', code: 'receivableAmount' },
    { model: "sale", type: "明细", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "sale", type: "明细", showable: "1", name: '可用库存', code: 'inventoryNum' },
    { model: "sale", type: "明细", showable: "1", name: '采购单号', code: 'purchaseCode' },
    { model: "sale", type: "明细", showable: "1", name: '备注', code: 'note' },

    //销售单明细-新增商品
    { model: "sale", type: "新增商品", showable: "1", name: '价格', code: 'price' },
    { model: "sale", type: "新增商品", showable: "1", name: '总计', code: 'amount' },

    //销售退货
    { model: "saleReturn", type: "主单", showable: "1", name: '退货单号', code: 'returnCode' },
    { model: "saleReturn", type: "主单", showable: "1", name: '原销售单号', code: 'saleCode' },
    { model: "saleReturn", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "saleReturn", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "saleReturn", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "saleReturn", type: "主单", showable: "1", name: '联系人', code: 'contact' },
    { model: "saleReturn", type: "主单", showable: "1", name: '电话', code: 'phone' },
    { model: "saleReturn", type: "主单", showable: "1", name: '退货数量', code: 'totalNum' },
    { model: "saleReturn", type: "主单", showable: "1", name: '退货金额', code: 'receivedAmount' },
    { model: "saleReturn", type: "主单", showable: "1", name: '已付金额', code: 'receivableAmount' },
    { model: "saleReturn", type: "主单", showable: "1", name: '退货成本', code: 'totalCost' },
    { model: "saleReturn", type: "主单", showable: "1", name: '结算方', code: 'settlementPartyName' },
    { model: "saleReturn", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "saleReturn", type: "主单", showable: "1", name: '结算方式', code: 'payMethodName' },
    { model: "saleReturn", type: "主单", showable: "1", name: '销售类型', code: 'salesTypeName' },
    { model: "saleReturn", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "saleReturn", type: "主单", showable: "1", name: '开票状态', code: 'invoiceStatus' },
    { model: "saleReturn", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "saleReturn", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "saleReturn", type: "主单", showable: "1", name: '库管员', code: 'storekeeper' },
    { model: "saleReturn", type: "主单", showable: "1", name: '入库时间', code: 'stockIoTime' },
    { model: "saleReturn", type: "主单", showable: "1", name: '退货日期', code: 'stockIoTime' },
    { model: "saleReturn", type: "主单", showable: "1", name: '结算日期', code: 'settleTime' },
    { model: "saleReturn", type: "主单", showable: "1", name: '结算员', code: 'reckoner' },
    { model: "saleReturn", type: "主单", showable: "1", name: '核销时间', code: 'writeOffTime' },
    { model: "saleReturn", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "saleReturn", type: "主单", showable: "1", name: '财务备注', code: 'fmsNote' },
    { model: "saleReturn", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "saleReturn", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //销售退货明细
    { model: "saleReturn", type: "明细", showable: "1", name: '销售单号', code: 'saleCode' },
    { model: "saleReturn", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "saleReturn", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "saleReturn", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "saleReturn", type: "明细", showable: "1", name: '销售数量', code: 'saleNum' },
    { model: "saleReturn", type: "明细", showable: "1", name: '销售单价', code: 'salePrice' },
    //{ model: "saleReturn", type: "明细", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "saleReturn", type: "明细", showable: "1", name: '退货数量', code: 'num' },
    { model: "saleReturn", type: "明细", showable: "1", name: '退货单价', code: 'price' },
    //{ model: "saleReturn", type: "明细", showable: "1", name: '退货折扣', code: 'discountRate' },
    { model: "saleReturn", type: "明细", showable: "1", name: '退货折扣金额', code: 'discountAmount' },
    { model: "saleReturn", type: "明细", showable: "1", name: '单项优惠金额', code: 'rdecreaseAmount' },
    { model: "saleReturn", type: "明细", showable: "1", name: '退货金额', code: 'amount' },
    { model: "saleReturn", type: "明细", showable: "1", name: '已退数量', code: 'sreturnNum' },
    { model: "saleReturn", type: "明细", showable: "1", name: '仓库', code: 'warehouseName' },
    { model: "saleReturn", type: "明细", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "saleReturn", type: "明细", showable: "1", name: '备注', code: 'note' },

    //销售单明细-新增商品
    { model: "saleReturn", type: "新增商品", showable: "1", name: '销售单价', code: 'salePrice' },
    { model: "saleReturn", type: "新增商品", showable: "1", name: '销售金额', code: 'saleTotal' },
    { model: "saleReturn", type: "新增商品", showable: "1", name: '退货单价', code: 'price' },
    { model: "saleReturn", type: "新增商品", showable: "1", name: '退货金额', code: 'amount' },

    //调出单
    { model: "saleOut", type: "主单", showable: "1", name: '调拨单号', code: 'code' },
    { model: "saleOut", type: "主单", showable: "1", name: '调出单号', code: 'transferOutCode' },
    { model: "saleOut", type: "主单", showable: "1", name: '调入单号', code: 'transferInCode' },
    { model: "saleOut", type: "主单", showable: "1", name: '调拨类型', code: 'transferTypeName' },
    { model: "saleOut", type: "主单", showable: "1", name: '调入门店', code: 'shopName' },
    { model: "saleOut", type: "主单", showable: "1", name: '调出门店', code: 'outShopName' },
    { model: "saleOut", type: "主单", showable: "1", name: '状态', code: 'status' },
    { model: "saleOut", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "saleOut", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "saleOut", type: "主单", showable: "1", name: '支付方式', code: 'payRecords' },
    { model: "saleOut", type: "主单", showable: "1", name: '调拨数量', code: 'totalNum' },
    { model: "saleOut", type: "主单", showable: "1", name: '成本金额', code: 'costAmount' },
    { model: "saleOut", type: "主单", showable: "1", name: '毛利', code: 'grossProfit' },
    { model: "saleOut", type: "主单", showable: "1", name: '应收金额', code: 'totalAmount' },
    { model: "saleOut", type: "主单", showable: "1", name: '优惠总金额', code: 'discountTotalAmount' },
    { model: "saleOut", type: "主单", showable: "1", name: '已收金额', code: 'aggregateAmount' },
    { model: "saleOut", type: "主单", showable: "1", name: '调入实体', code: 'bentityName' },
    { model: "saleOut", type: "主单", showable: "1", name: '调出实体', code: 'outBentityName' },
    { model: "saleOut", type: "主单", showable: "1", name: '制单员', code: 'applier' },
    { model: "saleOut", type: "主单", showable: "1", name: '调出员', code: 'transferOut' },
    { model: "saleOut", type: "主单", showable: "1", name: '调入员', code: 'transferIn' },
    { model: "saleOut", type: "主单", showable: "1", name: '制单日期', code: 'applyTime' },
    { model: "saleOut", type: "主单", showable: "1", name: '调出日期', code: 'transferOutTime' },
    { model: "saleOut", type: "主单", showable: "1", name: '调入日期', code: 'transferInTime' },
    { model: "saleOut", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "saleOut", type: "主单", showable: "1", name: '打印次数', code: 'printNum' },

    //调出单明细
    { model: "saleOut", type: "明细", showable: "1", name: '提示', code: '' },
    { model: "saleOut", type: "明细", showable: "1", name: '商品编号', code: 'materialCode' },
    { model: "saleOut", type: "明细", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "saleOut", type: "明细", showable: "1", name: '调拨数量', code: 'num' },
    { model: "saleOut", type: "明细", showable: "1", name: '折前单价', code: 'prePrice' },
    { model: "saleOut", type: "明细", showable: "1", name: '折前调拨金额', code: 'preAmount' },
    { model: "saleOut", type: "明细", showable: "1", name: '下浮', code: 'discountRate' },
    { model: "saleOut", type: "明细", showable: "1", name: '单价', code: 'price' },
    { model: "saleOut", type: "明细", showable: "1", name: '下浮', code: 'discountRate' },
    { model: "saleOut", type: "明细", showable: "1", name: '调拨总计', code: 'amount' },
    { model: "saleOut", type: "明细", showable: "1", name: '成本单价', code: 'costPrice' },
    { model: "saleOut", type: "明细", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "saleOut", type: "明细", showable: "1", name: '采购单号', code: 'saleOutCode' },
    { model: "saleOut", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "saleOut", type: "明细", showable: "1", name: '货位', code: 'outShelfCode' },
    { model: "saleOut", type: "明细", showable: "1", name: '仓库', code: 'outWarehouseName' },
    { model: "saleOut", type: "明细", showable: "1", name: '商品类型', code: 'typeName' },
    { model: "saleOut", type: "明细", showable: "1", name: '备注', code: 'note' },

    //库存明细
    { model: "stockDetail", type: "主单", showable: "1", name: '商品编码', code: 'materialCode' },
    { model: "stockDetail", type: "主单", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "stockDetail", type: "主单", showable: "1", name: '规格型号', code: 'model' },
    { model: "stockDetail", type: "主单", showable: "1", name: '仓库名称', code: 'warehouseName' },
    { model: "stockDetail", type: "主单", showable: "1", name: '仓库编号', code: 'warehouseCode' },
    { model: "stockDetail", type: "主单", showable: "1", name: '货位编号', code: 'shelfCode' },
    { model: "stockDetail", type: "主单", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "stockDetail", type: "主单", showable: "1", name: '占用库存数量', code: 'inventoryOccupied' },
    { model: "stockDetail", type: "主单", showable: "1", name: '可用库存数量', code: 'availableStock' },
    { model: "stockDetail", type: "主单", showable: "1", name: '入库数量', code: 'num' },
    { model: "stockDetail", type: "主单", showable: "1", name: '入库单价', code: 'latestPurPrice' },
    { model: "stockDetail", type: "主单", showable: "1", name: '入库金额', code: 'amount' },
    { model: "stockDetail", type: "主单", showable: "1", name: '库存金额', code: 'totalAmount' },
    { model: "stockDetail", type: "主单", showable: "1", name: '最近销价', code: 'lateSalePrice' },
    { model: "stockDetail", type: "主单", showable: "1", name: '供应商编号', code: 'supplierCode' },
    { model: "stockDetail", type: "主单", showable: "1", name: '供应商名称', code: 'supplierName' },
    { model: "stockDetail", type: "主单", showable: "1", name: '采购单号', code: 'purchaseCode' },
    { model: "stockDetail", type: "主单", showable: "1", name: '入库日期', code: 'stockIoTime' },
    { model: "stockDetail", type: "主单", showable: "1", name: '替换编号', code: 'replaceCode' },

    //库存统计
    { model: "stockStatic", type: "主单", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "stockStatic", type: "主单", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockStatic", type: "主单", showable: "1", name: '规格型号', code: 'model' },
    { model: "stockStatic", type: "主单", showable: "1", name: '移库记录', code: 'num' },
    { model: "stockStatic", type: "主单", showable: "1", name: '商品类型', code: 'typeName' },
    { model: "stockStatic", type: "主单", showable: "1", name: '替换编号', code: 'replaceCode' },
    { model: "stockStatic", type: "主单", showable: "1", name: '仓库', code: 'warehouseName' },
    { model: "stockStatic", type: "主单", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "stockStatic", type: "主单", showable: "1", name: '初始库存', code: 'inventoryInitial' },
    { model: "stockStatic", type: "主单", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "stockStatic", type: "主单", showable: "1", name: '占用库存', code: 'inventoryOccupied' },
    { model: "stockStatic", type: "主单", showable: "1", name: '可用库存', code: 'availableStock' },
    { model: "stockStatic", type: "主单", showable: "1", name: '进货价（参考价）', code: 'purchasePrice' },
    { model: "stockStatic", type: "主单", showable: "1", name: '销售价（参考价）', code: 'retailPrice' },
    { model: "stockStatic", type: "主单", showable: "1", name: '进货价（最近进价）', code: 'latestPurPrice' },
    { model: "stockStatic", type: "主单", showable: "1", name: '进货价（平均价）', code: 'averagePurchasePrice' },
    { model: "stockStatic", type: "主单", showable: "1", name: '库存成本（最近进价）', code: 'latestAmount' },
    { model: "stockStatic", type: "主单", showable: "1", name: '库存成本（平均价）', code: 'averageAmount' },
    { model: "stockStatic", type: "主单", showable: "1", name: '零售价（最近）', code: 'lateSalePrice' },
    { model: "stockStatic", type: "主单", showable: "1", name: '库存上限', code: 'limitUpper' },
    { model: "stockStatic", type: "主单", showable: "1", name: '库存下限', code: 'limitLower' },
    { model: "stockStatic", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },

    //库存盘点
    { model: "stockCheck", type: "主单", showable: "1", name: '盘库单号', code: 'stocktakingCode' },
    { model: "stockCheck", type: "主单", showable: "1", name: '盘点状态', code: 'status' },
    { model: "stockCheck", type: "主单", showable: "1", name: '盘点类型', code: 'type' },
    { model: "stockCheck", type: "主单", showable: "1", name: '盘点结果', code: 'result' },
    { model: "stockCheck", type: "主单", showable: "1", name: '仓库', code: 'warehouseName' },
    { model: "stockCheck", type: "主单", showable: "1", name: '系统库存', code: 'bookTotalNum' },
    { model: "stockCheck", type: "主单", showable: "1", name: '实际库存', code: 'realTotalNum' },
    { model: "stockCheck", type: "主单", showable: "1", name: '盘盈总数', code: 'surplusItem' },
    { model: "stockCheck", type: "主单", showable: "1", name: '盘亏总数', code: 'lossItem' },
    { model: "stockCheck", type: "主单", showable: "1", name: '差异数量', code: 'differenceTotalNum' },
    { model: "stockCheck", type: "主单", showable: "1", name: '差异金额', code: 'differenceTotalAmount' },
    { model: "stockCheck", type: "主单", showable: "1", name: '开始时间', code: 'startTime' },
    { model: "stockCheck", type: "主单", showable: "1", name: '结束时间', code: 'endTime' },
    { model: "stockCheck", type: "主单", showable: "1", name: '制单人', code: 'createUser' },
    { model: "stockCheck", type: "主单", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "stockCheck", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },
    { model: "stockCheck", type: "主单", showable: "1", name: '备注', code: 'note' },

    //库存盘点明细
    { model: "stockCheck", type: "明细", showable: "1", name: '商品编码', code: 'materialCode' },
    { model: "stockCheck", type: "明细", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "stockCheck", type: "明细", showable: "1", name: '仓库', code: 'warehouseName' },
    { model: "stockCheck", type: "明细", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "stockCheck", type: "明细", showable: "1", name: '最新采购价格', code: 'averagePurchasePrice' },
    { model: "stockCheck", type: "明细", showable: "1", name: '档案进价', code: 'purchasePrice' },
    { model: "stockCheck", type: "明细", showable: "1", name: '系统库存', code: 'inventoryNum' },
    { model: "stockCheck", type: "明细", showable: "1", name: '实际库存', code: 'realNum' },
    { model: "stockCheck", type: "明细", showable: "1", name: '盘点结果', code: 'result' },
    { model: "stockCheck", type: "明细", showable: "1", name: '差异量', code: 'differenceNum' },
    { model: "stockCheck", type: "明细", showable: "1", name: '差异金额', code: 'differenceAmount' },
    { model: "stockCheck", type: "明细", showable: "1", name: '报废数量', code: 'scrapNum' },
    { model: "stockCheck", type: "明细", showable: "1", name: '报废金额', code: 'scrapAmount' },
    { model: "stockCheck", type: "明细", showable: "1", name: '差异原因', code: 'note' },
    { model: "stockCheck", type: "明细", showable: "1", name: '报废原因', code: 'scrapReason' },

    //库存盘点明细-新增配件
    { model: "stockCheck", type: "新增配件", showable: "1", name: '最新采购价格', code: 'averagePurchasePrice' },
    { model: "stockCheck", type: "新增配件", showable: "1", name: '最近销售价', code: 'lateSalePrice' },
    { model: "stockCheck", type: "新增配件", showable: "1", name: '档案进价', code: 'purchasePrice' },
    { model: "stockCheck", type: "新增配件", showable: "1", name: '金额', code: 'amount' },

    //维修出库
    { model: "stockDelivery", type: "主单", showable: "1", name: '单据编号', code: 'maintenanceCode' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '出库数量', code: 'deliveryNum' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '车牌号', code: 'licensePlate' },
    { model: "stockDelivery", type: "主单", showable: "1", name: 'VIN码', code: 'vin' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '领料人', code: 'technicianNames' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '出库日期', code: 'stockIoTime' },
    { model: "stockDelivery", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },

    //维修出库明细-配件信息
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '状态', code: "status" },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '配件编号', code: 'materialCode' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '使用数量', code: 'quantityNum' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '已领数量', code: 'collectedNum' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '待领数量', code: 'unclaimedNum' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '退料数量', code: 'returnNum' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '所属仓库', code: 'warehouseName' },
    { model: "stockDelivery", type: "配件信息", showable: "1", name: '所属货位', code: 'shelfCode' },

    //维修出库明细-出库记录
    { model: "stockDelivery", type: "出库记录", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "stockDelivery", type: "出库记录", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockDelivery", type: "出库记录", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "stockDelivery", type: "出库记录", showable: "1", name: '出库数量', code: 'num' },
    { model: "stockDelivery", type: "出库记录", showable: "1", name: '所属仓库', code: 'warehouseName' },
    { model: "stockDelivery", type: "出库记录", showable: "1", name: '所属货位', code: 'shelfCode' },

    //维修出库明细-入库记录
    { model: "stockDelivery", type: "入库记录", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "stockDelivery", type: "入库记录", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockDelivery", type: "入库记录", showable: "1", name: '库存数量', code: 'inventoryNum' },
    { model: "stockDelivery", type: "入库记录", showable: "1", name: '入库数量（退料）', code: 'num' },
    { model: "stockDelivery", type: "入库记录", showable: "1", name: '所属仓库', code: 'warehouseName' },
    { model: "stockDelivery", type: "入库记录", showable: "1", name: '所属货位', code: 'shelfCode' },

    //维修借件
    { model: "stockBorrow", type: "主单", showable: "1", name: '借件单号', code: 'borrowCode' },
    { model: "stockBorrow", type: "主单", showable: "1", name: '借件人', code: 'borrowPerson' },
    { model: "stockBorrow", type: "主单", showable: "1", name: '制单人', code: 'createUser' },
    { model: "stockBorrow", type: "主单", showable: "1", name: '借件时间', code: 'createTime' },
    { model: "stockBorrow", type: "主单", showable: "1", name: '还件时间', code: 'returnTime' },
    { model: "stockBorrow", type: "主单", showable: "1", name: '备注', code: 'note' },

    //维修借件明细
    { model: "stockBorrow", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "stockBorrow", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockBorrow", type: "明细", showable: "1", name: '库存数量', code: 'inventoryNums' },
    { model: "stockBorrow", type: "明细", showable: "1", name: '借件数量', code: 'borrowNum' },
    { model: "stockBorrow", type: "明细", showable: "1", name: '采购单号', code: 'stockBorrowCode' },
    { model: "stockBorrow", type: "明细", showable: "1", name: '还件时间', code: 'returnTime' },

    //出库单据
    { model: "stockOut", type: "主单", showable: "1", name: '单据编号', code: 'tradeCode' },
    { model: "stockOut", type: "主单", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "stockOut", type: "主单", showable: "1", name: '出库数量', code: 'inTotal' },
    { model: "stockOut", type: "主单", showable: "1", name: '单位名称', code: 'userName' },
    { model: "stockOut", type: "主单", showable: "1", name: '制单人', code: 'billingClerk' },
    { model: "stockOut", type: "主单", showable: "1", name: '制单日期', code: 'billingTime' },
    { model: "stockOut", type: "主单", showable: "1", name: '库管员', code: 'createUser' },
    { model: "stockOut", type: "主单", showable: "1", name: '出库时间', code: 'stockIoTime' },
    { model: "stockOut", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },
    { model: "stockOut", type: "主单", showable: "1", name: '备注', code: 'note' },

    //出库单据明细
    { model: "stockOut", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "stockOut", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockOut", type: "明细", showable: "1", name: '所属库房', code: 'warehouseName' },
    { model: "stockOut", type: "明细", showable: "1", name: '所属货位', code: 'shelfCode' },
    { model: "stockOut", type: "明细", showable: "1", name: '数量', code: 'num' },
    { model: "stockOut", type: "明细", showable: "1", name: '单价', code: 'price' },
    { model: "stockOut", type: "明细", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "stockOut", type: "明细", showable: "1", name: '总计', code: 'amount' },

    //入库单据
    { model: "stockIn", type: "主单", showable: "1", name: '单据编号', code: 'tradeCode' },
    { model: "stockIn", type: "主单", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "stockIn", type: "主单", showable: "1", name: '入库数量', code: 'inTotal' },
    { model: "stockIn", type: "主单", showable: "1", name: '单位名称', code: 'userName' },
    { model: "stockIn", type: "主单", showable: "1", name: '制单人', code: 'billingClerk' },
    { model: "stockIn", type: "主单", showable: "1", name: '制单日期', code: 'billingTime' },
    { model: "stockIn", type: "主单", showable: "1", name: '库管员', code: 'createUser' },
    { model: "stockIn", type: "主单", showable: "1", name: '出库时间', code: 'stockIoTime' },
    { model: "stockIn", type: "主单", showable: "1", name: '所属门店', code: 'shopName' },
    { model: "stockIn", type: "主单", showable: "1", name: '备注', code: 'note' },

    //入库单据明细
    { model: "stockIn", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "stockIn", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "stockIn", type: "明细", showable: "1", name: '所属库房', code: 'warehouseName' },
    { model: "stockIn", type: "明细", showable: "1", name: '所属货位', code: 'shelfCode' },
    { model: "stockIn", type: "明细", showable: "1", name: '数量', code: 'num' },
    { model: "stockIn", type: "明细", showable: "1", name: '单价', code: 'price' },
    { model: "stockIn", type: "明细", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "stockIn", type: "明细", showable: "1", name: '总计', code: 'amount' },

    //调拨管理
    { model: "stockAlloc", type: "主单", showable: "1", name: '商品编号', code: 'materialCode' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '调拨数量', code: 'num' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '调拨单号', code: 'transferCode' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '调出门店', code: 'outShopName' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '已出库数量', code: 'stockIoNum' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '出库状态', code: 'stockOutStatus' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '出库时间', code: 'transferOutTime' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '调入门店', code: 'shopName' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '已入库数量', code: 'inStockIoNum' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '入库状态', code: 'stockInStatus' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '入库时间', code: 'transferInTime' },
    { model: "stockAlloc", type: "主单", showable: "1", name: '备注', code: 'note' },

    //采购计划
    { model: "purchasePlan", type: "主单", showable: "1", name: '采购计划号', code: 'planCode' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '厂家订单号', code: 'orderCode' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '采购类型', code: 'purchaseTypeName' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '商品类型', code: 'materialTypeName' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '采购数量', code: 'totalNum' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '已到数量', code: 'arrivedNum' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '未到数量', code: 'unarrivedNum' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '采购总金额', code: 'totalAmount' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '制单人', code: 'createUser' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '发运方式', code: 'deliveryMethodName' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '是否直发', code: 'isDirect' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "purchasePlan", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //采购计划明细
    { model: "purchasePlan", type: "明细", showable: "1", name: '配件编号', code: 'materialCode' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '采购数量', code: 'planNum' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '采购单价', code: 'price' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '采购金额', code: 'amount' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '所属仓库', code: 'warehouseCode' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '所属货位', code: 'shelfCode' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '最小起订量', code: 'minNum' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '到货数量', code: 'num' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '已到货数量', code: 'arrivedTotal' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '未到货数量', code: 'unarrivedNum' },
    { model: "purchasePlan", type: "明细", showable: "1", name: '备注', code: 'note' },

    //采购计划明细-新增配件
    { model: "purchasePlan", type: "新增配件", showable: "1", name: '单价', code: 'purchasePrice' },
    { model: "purchasePlan", type: "新增配件", showable: "1", name: '采购金额', code: 'amount' },

    //采购单
    { model: "purchase", type: "主单", showable: "1", name: '采购单号', code: 'purchaseCode' },
    { model: "purchase", type: "主单", showable: "1", name: '调拨单号', code: 'transferOrder' },
    { model: "purchase", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "purchase", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "purchase", type: "主单", showable: "1", name: '采购类型', code: 'purchaseTypeName' },
    { model: "purchase", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "purchase", type: "主单", showable: "1", name: '结算方式', code: 'payMethodName' },
    { model: "purchase", type: "主单", showable: "1", name: '采购数量', code: 'totalNum' },
    { model: "purchase", type: "主单", showable: "1", name: '到货数量', code: 'arrivedNum' },
    { model: "purchase", type: "主单", showable: "1", name: '损坏数量', code: 'damageTotalNum' },
    { model: "purchase", type: "主单", showable: "1", name: '入库数量', code: 'stockIoNum' },
    { model: "purchase", type: "主单", showable: "1", name: '已付金额', code: 'paidAmount' },
    { model: "purchase", type: "主单", showable: "1", name: '退货数量', code: 'returnTotalNum' },
    { model: "purchase", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "purchase", type: "主单", showable: "1", name: '联系人', code: 'contact' },
    { model: "purchase", type: "主单", showable: "1", name: '电话', code: 'phone' },
    { model: "purchase", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "purchase", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "purchase", type: "主单", showable: "1", name: '库管员', code: 'storekeeper' },
    { model: "purchase", type: "主单", showable: "1", name: '入库日期', code: 'stockIoTime' },
    { model: "purchase", type: "主单", showable: "1", name: '结算员', code: 'reckoner' },
    { model: "purchase", type: "主单", showable: "1", name: '结算日期', code: 'settleTime' },
    { model: "purchase", type: "主单", showable: "1", name: '核销日期', code: 'writeOffTime' },
    { model: "purchase", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "purchase", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "purchase", type: "主单", showable: "1", name: '商品类型', code: 'materialTypeName' },
    { model: "purchase", type: "主单", showable: "1", name: '采购计划号', code: 'planCode' },
    { model: "purchase", type: "主单", showable: "1", name: '调入单号', code: 'allocationCode' },
    { model: "purchase", type: "主单", showable: "1", name: '供应商', code: 'supplierName' },
    { model: "purchase", type: "主单", showable: "1", name: '采购金额', code: 'payableAmount' },
    { model: "purchase", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //采购明细
    { model: "purchase", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "purchase", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "purchase", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "purchase", type: "明细", showable: "1", name: '采购数量', code: 'num' },
    { model: "purchase", type: "明细", showable: "1", name: '采购单价', code: 'price' },
    { model: "purchase", type: "明细", showable: "1", name: '采购金额', code: 'amount' },
    { model: "purchase", type: "明细", showable: "1", name: '到货数量', code: 'confirmNum' },
    { model: "purchase", type: "明细", showable: "1", name: '损坏数量', code: 'damageNum' },
    { model: "purchase", type: "明细", showable: "1", name: '仓库', code: 'warehouseCode' },
    { model: "purchase", type: "明细", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "purchase", type: "明细", showable: "1", name: '备注', code: 'note' },

    //采购单-新增配件
    { model: "purchase", type: "新增配件", showable: "1", name: '单价', code: 'purchasePrice' },
    { model: "purchase", type: "新增配件", showable: "1", name: '采购金额', code: 'amount' },

    //采购退货
    { model: "purchaseReturn", type: "主单", showable: "1", name: '退货单号', code: 'returnCode' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '支付状态', code: 'payStatus' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '退货数量', code: 'totalNum' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '已收金额', code: 'paidAmount' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '结算类型', code: 'payType' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '结算方式', code: 'payMethodName' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '单据类型', code: 'documentTypeName' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '发票类型', code: 'invoiceTypeName' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '联系人', code: 'contact' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '联系电话', code: 'phone' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '制单员', code: 'createUser' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '结算员', code: 'reckoner' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '结算时间', code: 'settleTime' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '库管', code: 'storekeeper' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '出库时间', code: 'stockIoTime' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '核销时间', code: 'writeOffTime' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '作废原因', code: 'cancelReason' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '供应商', code: 'supplierName' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '采退金额', code: 'payableAmount' },
    { model: "purchaseReturn", type: "主单", showable: "1", name: '打印次数', code: 'printingTimes' },

    //采购退货明细
    { model: "purchaseReturn", type: "明细", showable: "1", name: '配件编码', code: 'materialCode' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '采购数量', code: 'purchaseNum' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '采购单价', code: 'purchasePrice' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '退货数量', code: 'num' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '退货单价', code: 'price' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '退货金额', code: 'amount' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '采购单号', code: 'purchaseCode' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '已退货数量', code: 'preturnNum' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '可用库存数量', code: 'inventoryNum' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '仓库', code: 'warehouseCode' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '货位', code: 'shelfCode' },
    { model: "purchaseReturn", type: "明细", showable: "1", name: '备注', code: 'note' },

    //采购退货-新增配件
    { model: "purchaseReturn", type: "新增配件", showable: "1", name: '单价', code: 'price' },
    { model: "purchaseReturn", type: "新增配件", showable: "1", name: '金额', code: 'amount' },

    //调入单
    { model: "purchaseIn", type: "主单", showable: "1", name: '调拨单号', code: 'code' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调入单号', code: 'transferInCode' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调拨类型', code: 'transferTypeName' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调入门店', code: 'shopName' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调入实体', code: 'bentityName' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调出门店', code: 'outShopName' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调出实体', code: 'outBentityName' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调拨数量', code: 'totalNum' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '成本金额', code: 'costAmount' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '毛利', code: 'grossProfit' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '应付金额', code: 'totalAmount' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '优惠总金额', code: 'discountTotalAmount' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '已付金额', code: 'paidAmount' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '制单员', code: 'applier' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调出员', code: 'transferOut' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调入员', code: 'transferIn' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '制单日期', code: 'applyTime' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调出日期', code: 'transferOutTime' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '调入日期', code: 'transferInTime' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '备注', code: 'inNote' },
    { model: "purchaseIn", type: "主单", showable: "1", name: '打印次数', code: 'printNum' },

    //调入单明细
    { model: "purchaseIn", type: "明细", showable: "1", name: '商品编号', code: 'materialCode' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '单位', code: 'unitName' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '调拨数量', code: 'num' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '折前单价', code: 'prePrice' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '折前调拨金额', code: 'preAmount' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '下浮', code: 'discountRate' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '单价', code: 'price' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '调拨金额', code: 'amount' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '成本单价', code: 'costPrice' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '调入仓库', code: 'inWarehouseCode' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '调入货位', code: 'inShelfCode' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '调出仓库', code: 'outWarehouseName' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '调出货位', code: 'outShelfCode' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '商品类型', code: 'typeName' },
    { model: "purchaseIn", type: "明细", showable: "1", name: '采购单号', code: 'purchaseCode' },

    //出入库记录明细
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '单据编号', code: 'code' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '配件编号', code: 'materialCode' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '所属仓库', code: 'warehouseName' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '所属货位', code: 'shelfCode' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '出库数量', code: 'num' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '单价', code: 'price' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '出库数量', code: 'amount' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '制单人', code: 'createUser' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '库管员', code: 'storekeeper' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '出库时间', code: 'stockIoTime' },
    { model: "inOutDetailStatic", type: "出库记录", showable: "1", name: '单位名称', code: 'userName' },

    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '单据编号', code: 'code' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '配件编号', code: 'materialCode' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '配件名称', code: 'materialName' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '所属仓库', code: 'warehouseName' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '所属货位', code: 'shelfCode' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '入库数量', code: 'num' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '单价', code: 'price' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '入库金额', code: 'amount' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '制单人', code: 'createUser' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '库管员', code: 'storekeeper' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '入库时间', code: 'stockIoTime' },
    { model: "inOutDetailStatic", type: "入库记录", showable: "1", name: '单位名称', code: 'userName' },

    //采购明细报表
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '供应商名称', code: 'supplierName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '供应商类型', code: 'supplierTypeName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '单据编号', code: 'code' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '采购类型', code: 'orderTypeName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '结算类型', code: 'payTypeName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '商品编号', code: 'materialCode' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '商品类型', code: 'typeName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '配件采购频次', code: 'purchaseCount' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '配件采退频次', code: 'preturnCount' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '采购价格', code: 'price' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '采购数量', code: 'num' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '采购金额', code: 'amount' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '制单人', code: 'createUser' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '制单时间', code: 'createTime' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '结算时间', code: 'settleTime' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '从属门店', code: 'shopName' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '结算日期', code: 'settleTime' },
    { model: "purchaseDetailStatic", type: "主单", showable: "1", name: '备注', code: 'note' },

    //销售明细报表
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '客户类型', code: 'customerTypeName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '单据编号', code: 'code' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '单据状态', code: 'status' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售类型', code: 'salesTypeName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '结算类型', code: 'payTypeName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '商品编号', code: 'materialCode' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '商品类型', code: 'typeName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售数量', code: 'num' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售价格', code: 'price' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售金额', code: 'amount' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售成本', code: 'costAmount' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售毛利', code: 'profit' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '制单人', code: 'createUser' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '结算日期', code: 'settleTime' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '物料编号', code: 'insideCode' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '物料名称', code: 'insideName' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '替换编号', code: 'replaceCode' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '销售订单号', code: 'transferCode' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '积压标记', code: 'overstock' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '配件销售频次', code: 'saleCount' },
    { model: "saleDetailStatic", type: "主单", showable: "1", name: '配件销退频次', code: 'sreturnCount' },

    //维修明细报表
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '客户名称', code: 'customerName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '单据编号', code: 'code' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '单据类型', code: 'tradeTypeName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '维修类型', code: 'serviceTypeName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '结算类型', code: 'payTypeName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '商品名称', code: 'materialName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '商品编号', code: 'materialCode' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '商品类型', code: 'typeName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '销售数量', code: 'num' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '销售价格', code: 'price' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '销售金额', code: 'amount' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '销售成本', code: 'costAmount' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '销售毛利', code: 'profit' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '制单人', code: 'createUser' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '制单日期', code: 'createTime' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '结算日期', code: 'settleTime' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '物料编号', code: 'insideCode' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '物料名称', code: 'insideName' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '替换编号', code: 'replaceCode' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '销售订单号', code: 'transferCode' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '积压标记', code: 'overstock' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '备注', code: 'note' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '配件销售频次', code: 'saleCount' },
    { model: "orderDetailStatic", type: "主单", showable: "1", name: '配件销退频次', code: 'sreturnCount' },

    //其他-配件历史弹窗(采购销售历史通用查询弹框)
    { model: "other", type: "配件历史", showable: "1", name: '单价', code: 'price' },
    { model: "other", type: "配件历史", showable: "1", name: '折扣', code: 'discountRate' },
    { model: "other", type: "配件历史", showable: "1", name: '工时费', code: 'amount' },

    //采购订单台账
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '申请单位', code: 'shopName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '申请日期', code: 'fillingTime' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '审批日期', code: 'approvalTime' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '下订单日期', code: 'createTime' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '采购批次', code: 'batchCode' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '供货单位', code: 'supplierName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '材料编码', code: 'materialCode' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '材料大类', code: 'ptypeName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '材料小类', code: 'typeName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '材料名称', code: 'materialName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '品牌', code: 'brandName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '适用车型', code: 'vehicleModel' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '规格、型号', code: 'model' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '计量单位(采购)', code: 'unitName' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '采购数量', code: 'planNum' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '采购单价(含税)', code: 'price' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '采购总价(含税)', code: 'amount' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '交货期(h)', code: 'deliveryTime' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '收货日期', code: 'arrivedTime' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '专票发票税额', code: 'tax' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '成本总价(不含税)', code: 'totalCost' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '成本单价(不含税)', code: 'costPrice' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '采购到货数量', code: 'arrivedTotal' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '未到货数量', code: 'unarrivedNum' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '退货数量', code: 'preturnNum' },
    { model: "purchaseOrderLog", type: "主单", showable: "1", name: '备注(库房专用)', code: 'note' },

];